export default __webpack_public_path__ + "static/goods-toy-dc829a0fcc3d7e17043e8dc333d7b300.png";